module.exports = __webpack_public_path__ + "assets/loading.24625f1.svg";